<template>
  <div>
    <el-table
      :data="payedCommissionList"
      v-if="viewFlag"
      tooltip-effect="dark"
      style="margin:auto"
    >
      <!-- 上课日期时间 -->
      <el-table-column
        prop="dateAndTime"
        :label="$t('p0416.dateTime')"
        align="center"
        min-width="100"
        :formatter="createTimeFormat"
      ></el-table-column>
      <!-- 课程编号 -->
      <el-table-column
        prop="courseNumberView"
        :label="$t('p0416.courseNumber')"
        align="center"
        min-width="60"
      ></el-table-column>
      <!-- 课程名称 -->
      <el-table-column
        prop="courseName"
        :label="$t('p0416.courseName')"
        align="left"
        min-width="150"
      ></el-table-column>
      <!-- 佣金总额 -->
      <el-table-column
        prop="totalCommission"
        :label="$t('p0416.totalCommission')"
        align="center"
        min-width="60"
      ></el-table-column>
      <!-- 已付金额 -->
      <el-table-column
        prop="payCommission"
        :label="$t('p0416.amountPaid')"
        align="center"
        min-width="60"
      >
      </el-table-column>
      <!-- 货币 -->
      <el-table-column
        prop="currencyView"
        :label="$t('p0416.currency')"
        align="center"
        min-width="40"
      >
      </el-table-column>
      <!-- 支付时间 -->
      <el-table-column
        prop="commissionPayTime"
        :label="$t('p0416.paymentTime')"
        align="center"
        min-width="100"
        :formatter="createTimeFormat1"
      ></el-table-column>
      <!-- 操作 -->
      <el-table-column :label="$t('common.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="text" @click="getDetails(scope.row)">{{
            $t("p0416.details")
          }}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="viewFlag">
      <!-- 分页 -->
      <el-row style="text-align: right; margin: 20px">
        <el-col :span="24">
          <div class="block">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPageCo"
              :page-sizes="[10, 20, 50]"
              :page-size="pageSizeCo"
              layout="total, sizes, prev, pager, next"
              :total="totalCo"
            >
            </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 课程结算详情 -->
    <p0420
      ref="p0420"
      :detailList="detailList"
      @getViewFlag="getViewFlag"
      v-if="!viewFlag"
    ></p0420>
  </div>
</template>

<script>
import qs from "qs";
import p0420 from "../../Marketing/CouponCode/P0420";
import moment from "moment";
export default {
  components: {
    p0420
  },
  data() {
    return {
      detailList: [],
      // 显示画面标志
      viewFlag: true,
      payedCommissionList: [],
      // 当前页
      currentPageCo: 1,
      // 每页件数
      pageSizeCo: 20,
      totalCo: 0
    };
  },
  methods: {
    // 每页数据条数设定
    handleSizeChange(val) {
      this.pageSizeCo = val;
      this.currentPageCo = 1;
      //判断更改页码是否需要查询
      if (
        this.payedCommissionList == undefined ||
        this.payedCommissionList.length <= 0
      ) {
        return;
      }
      this.getPayedCommissionList(false);
      // console.log(`每页 ${val} 条`);
    },
    // 当前页显示
    handleCurrentChange(val) {
      this.currentPageCo = val;
      this.getPayedCommissionList(false);
      // console.log(`当前页: ${val}`);
    },
    // 初始化数据
    getPayedCommissionList(val) {
      if (val) {
        // 分页数据初始化
        this.currentPageCo = 1;
        this.totalCo = 0;
      }
      const loading = this.$loading({
        lock: true,
        text: this.$t("common.loading"),
        spinner: "el-icon-loading",
        background: "hsla(0, 0%, 100%, 0.9)",
        target: document.querySelector("#main-container")
      });
      let url = "/api/greenJacketOrder/searchPayedCommissions";
      this.$http
        .post(url, {
          // 当前页
          currentSizeCo: (this.currentPageCo - 1) * this.pageSizeCo,
          // 页数
          pageSizeCo: this.pageSizeCo,
          // 总数
          totalCo: this.totalCo
        })
        .then(response => {
          loading.close();
          if (response.data.code === 200) {
            this.payedCommissionList = response.data.data;
            if (this.payedCommissionList) {
              this.totalCo = this.payedCommissionList[0].totalCo;
            } else {
              this.totalCo = 0;
            }
            console.log(
              "🚀 ~ file: P0414.vue:141 ~ searchPayedCommissions ~ response.data.data",
              response.data.data
            );
          } else {
            this.$message.error(response.data.message);
          }
        })
        .catch(err => {
          console.log(err);
          loading.close();
          this.$message.error(this.$t("common.anErrorOccurred"));
        });
    },
    // 查询明细
    getDetails(row) {
      // console.log(row);
      // 显示课程结算信息
      this.viewFlag = false;
      // 传递课程数据
      this.detailList = row;
    },
    // 控制显示
    getViewFlag(data) {
      this.viewFlag = data;
    },
    //创建日期格式化时间
    createTimeFormat(row) {
      if (row.dateAndTime != null && row.dateAndTime != "") {
        return moment(row.dateAndTime).format("YYYY-MM-DD HH:mm");
      }
    },
    //创建日期格式化时间1
    createTimeFormat1(row) {
      if (row.commissionPayTime != null && row.commissionPayTime != "") {
        return moment(row.commissionPayTime).format("YYYY-MM-DD HH:mm");
      }
    }
  },
  mounted() {
    this.getPayedCommissionList(true);
    // console.log("aaa",this.$router.options.routes);
  }
};
</script>

<style lang="scss" scoped>
.main {
  width: 90%;
  margin: 0 auto;
  padding-top: 17px;
  display: flex;
}
>>> .el-table__row {
  height: 42px;
}
>>> .el-table thead {
  font-family: "Arial Negreta", "Arial Normal", "Arial";
  color: #333333;
  font-size: 16px;
}
>>> .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  line-height: 18px;
  border-bottom: 0.5px solid rgb(170, 170, 170);
}
>>> .el-table--border::after,
.el-table--group::after,
.el-table::before {
  background: none;
}
>>> .el-table__header {
  border-bottom: 3px solid rgb(170, 170, 170);
}
</style>



// WEBPACK FOOTER //
// src/views/Marketing/CouponCode/P0418.vue